<template>
  <div id="app" v-cloak>
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
// import { debounce } from '@/utils/debounce'
export default {
  name: 'App',
  components: {},
  data () {
    return {}
  },
  mounted () {
    this.$nextTick(() => {
      // window.addEventListener('resize', debounce(this.showMobOrPc, 300), false)
    })
  },
  watch: {
    $route (to, from) {
      // this.showMobOrPc()
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
  },
  beforeDestroy () {
    // window.removeEventListener('resize', debounce(this.showMobOrPc, 300), false)
  },
  methods: {
    // showMobOrPc () {
    //   if (this._isMobile() || this._isSmall()) {
    //     if (this.$router.history.current.fullPath === '/' || this.$router.history.current.fullPath.indexOf('/pc') > -1) {
    //       this.$router.replace('/mob')
    //     }
    //   } else {
    //     if (this.$router.history.current.fullPath.indexOf('/mob') > -1) {
    //       this.$router.replace('/')
    //     }
    //   }
    // },
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    _isSmall () {
      let screen = document.documentElement.clientWidth || document.body.clientWidth
      if (screen < 1280) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Microsoft YaHei', 'PingFang SC', 'Avenir', Helvetica, Tahoma, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
}
body {
  /* font-family: SiYuan-Regular !important; */
}
/*css样式*/
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue